module.exports = __webpack_public_path__ + "img/facepaint.53e41a5.jpg";